import { render, staticRenderFns } from "./SemenCollectionListview.vue?vue&type=template&id=2c6444aa&"
import script from "./SemenCollectionListview.vue?vue&type=script&lang=js&"
export * from "./SemenCollectionListview.vue?vue&type=script&lang=js&"
import style0 from "./SemenCollectionListview.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports